export const CFX_PROTOCOL = 'cfx_protocol';
export const CFX_96_PLATE = 'cfx_96_plate';
export const CFX_384_PLATE = 'cfx_384_plate';
export const CFX_RUN = 'cfx_run';
